export default "__VITE_ASSET__8a6a3af4__$_?inline__"